import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
export default {
  name: "bnb-apartment-audit",
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20,
        userTypeStatus: 3
      },
      // 搜索表单

      filterList: [],
      districtList: [],
      adminList: [],
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0 // 总数
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getHouseFilterType();
            _this.getAdminList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    // 房源审核
    auditHouse: function auditHouse(row, status) {
      var _this2 = this;
      this.$confirm("确认操作， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.auditHouse({
                house_id: row.id,
                status: status
              });
            case 1:
              _this2.$message.success("操作成功");
              _this2.getData();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))).catch(function () {});
    },
    getAdminList: function getAdminList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$api.getAdminUser({
                type: "all"
              });
            case 1:
              res = _context3.v;
              _this3.adminList = res.data;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    updateItem: function updateItem(row) {
      this.$router.push({
        path: "/house/update",
        query: {
          id: row.id,
          userId: row.userInfo.id
        }
      });
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var price, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (type === "search") {
                _this4.searchForm.pn = 1;
              }
              if (_this4.searchForm.priceId && _this4.searchForm.priceId.length > 0) {
                price = _this4.searchForm.priceId.split(",");
                _this4.searchForm.minPrice = price[0];
                _this4.searchForm.maxPrice = price[1];
              }
              _this4.searchForm.type = 2; // 待审核
              _this4.searchForm.houseType = 2;
              _this4.tableLoading = true;
              _context4.n = 1;
              return _this4.$api.getHouseList(_this4.searchForm);
            case 1:
              res = _context4.v;
              _this4.tableData = res.data.list;
              _this4.total = res.data.count;
              _this4.tableLoading = false;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getHouseFilterType: function getHouseFilterType() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this5.$api.getHouseFilterType();
            case 1:
              res = _context5.v;
              _this5.filterList = res.data;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    getDistrictList: function getDistrictList(val) {
      var _this6 = this;
      if (val) {
        this.filterList.cityList.forEach(function (value) {
          if (value.id === val) {
            _this6.searchForm.districtId = "";
            _this6.districtList = value.item;
          }
        });
      } else {
        this.districtList = [];
      }
    },
    tableRowClassName: function tableRowClassName(_ref2) {
      var row = _ref2.row;
      if (row.isSensitive) {
        return "warning-row";
      }
      if (row.blackIp) {
        return "black-ip-row";
      }
      if (row.censor_status == "block") {
        return "warning-row";
      }
      return "";
    }
  }
};